import { hasParentNode } from "./dom";
/**
 * Get the interaction attribution name for an element
 */
export function interactionAttributionForElement(el) {
    // Our first preference is to use the data-sctrack attribute from anywhere in the tree
    var trackId = getClosestScTrackAttribute(el);
    if (trackId) {
        return trackId;
    }
    // The second preference is to use the element's ID
    if (el.id) {
        return el.id;
    }
    // The third preference is to use the text content of a button or link
    var isSubmitInput = el.tagName === "INPUT" && el.type === "submit";
    var isButton = el.tagName === "BUTTON";
    var isLink = el.tagName === "A";
    if (isSubmitInput && el.value) {
        return el.value;
    }
    if ((isButton || isLink) && el.innerText) {
        return el.innerText;
    }
    if (hasParentNode(el)) {
        return interactionAttributionForElement(el.parentNode);
    }
    // No suitable attribute was found
    return "";
}
export function getClosestScTrackAttribute(el) {
    var _a;
    if (el.hasAttribute("data-sctrack")) {
        var trackId = (_a = el.getAttribute("data-sctrack")) === null || _a === void 0 ? void 0 : _a.trim();
        if (trackId) {
            return trackId;
        }
    }
    if (hasParentNode(el)) {
        return getClosestScTrackAttribute(el.parentNode);
    }
    return null;
}
